export const maxMobileSize = 1160
